import { TableCell } from "@mui/material";
import React, { FC } from "react";
import SkeletonItem from "../../../SkeletonItem/SkeletonItem";
import Tooltip from "../../../Tooltip/Tooltip";
import { rowCellStyle } from "../TableHeading/TableHeading.styles";
import alertIcon from "../../../../assets/alert.svg";

const DashboardTableCell: FC<{
  value?: string | number | null;
  span?: string | number;
  showPercentage?: boolean;
  ignoreSkeleton?: boolean;
  avatar?: string;
}> = ({ value, ignoreSkeleton, span, avatar }) => {
  return (
    <>
      <TableCell style={rowCellStyle} align="center">
        {value === null ? (
          <div style={{ position: "relative" }}>
            <Tooltip
              icon={alertIcon}
              tooltipDescription="Wrong club configuration"
              leftPositioning={-0.8}
            />
          </div>
        ) : value !== undefined && !value.toString().includes("undefined") ? (
          <div
            style={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              gap: "0.5em",
            }}
          >
            {avatar && (
              <img
                src={avatar}
                style={{ width: "16px", height: "16px", borderRadius: "50%" }}
              />
            )}
            <>{value}</>
            {span && (
              <span style={{ color: "var(--primary-green-color)" }}>
                {span}
              </span>
            )}
          </div>
        ) : !ignoreSkeleton ? (
          <SkeletonItem width={60} height={20} borderRadius={5} />
        ) : null}
      </TableCell>
    </>
  );
};

export default DashboardTableCell;
